// extracted by mini-css-extract-plugin
module.exports = {"name":"ArchitectNotLinkedPopup_name__2xOtc","description":"ArchitectNotLinkedPopup_description__16Nf_"};